import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import {
  previewRateQuote,
  PreviewRqResult,
  publishRateQuote,
  PublishRqResult,
  submitRateQuote,
  SubmitRqResult
} from '../../modules/rate-quote';
import { MerchandisingPayload } from '../../modules/rate-quote/merchandising';
import { merchandisingPayloadSelector } from '../../selectors/offer';
import {
  previewRateQuoteFailure,
  previewRateQuoteRequest,
  previewRateQuoteSuccess,
  publishRateQuoteFailure,
  publishRateQuoteRequest,
  publishRateQuoteSuccess,
  submitRateQuoteFailure,
  submitRateQuoteRequest,
  submitRateQuoteSuccess
} from './slice';

export function* handlePublishRequest({ payload }: ReturnType<typeof publishRateQuoteRequest>) {
  try {
    const merchandisingSet: MerchandisingPayload = yield select(merchandisingPayloadSelector);
    const { success, error, json }: PublishRqResult = yield call(
      publishRateQuote,
      payload,
      merchandisingSet
    );
    if (success) {
      yield put(publishRateQuoteSuccess(json!));
    } else {
      yield put(publishRateQuoteFailure(error!));
    }
  } catch (err) {
    const error = err instanceof Error ? err.message : JSON.stringify(err);
    yield put(publishRateQuoteFailure(error));
  }
}

export function* handlePreviewRequest({ payload }: ReturnType<typeof previewRateQuoteRequest>) {
  try {
    const merchandisingSet: MerchandisingPayload = yield select(merchandisingPayloadSelector);
    const { success, json, error }: PreviewRqResult = yield call(
      previewRateQuote,
      payload,
      merchandisingSet
    );
    if (success) {
      yield put(previewRateQuoteSuccess(json!.link));
    } else {
      yield put(previewRateQuoteFailure(error!));
    }
  } catch (err) {
    const error = err instanceof Error ? err.message : JSON.stringify(err);
    yield put(previewRateQuoteFailure(error));
  }
}

export function* handleSubmitRequest({ payload }: ReturnType<typeof submitRateQuoteRequest>) {
  try {
    const { success, error }: SubmitRqResult = yield call(submitRateQuote, payload);
    if (success) {
      yield put(submitRateQuoteSuccess());
    } else {
      yield put(submitRateQuoteFailure(error!));
    }
  } catch (err) {
    const error = err instanceof Error ? err.message : JSON.stringify(err);
    yield put(submitRateQuoteFailure(error));
  }
}

export const linkModalSaga = function* () {
  yield all([
    takeEvery(publishRateQuoteRequest.type, handlePublishRequest),
    takeEvery(previewRateQuoteRequest.type, handlePreviewRequest),
    takeEvery(submitRateQuoteRequest.type, handleSubmitRequest)
  ]);
};
